var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsOsint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(-298 -674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(154.004 368.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft",
    transform: "translate(144 306.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M272,35.033h35.033V2.336A2.336,2.336,0,0,0,304.7,0H272Z",
    transform: "translate(-232.296)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M35.033,35.033V0H2.336A2.336,2.336,0,0,0,0,2.336v32.7Z",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M35.033,272H0v32.7a2.336,2.336,0,0,0,2.336,2.336h32.7Z",
    transform: "translate(0 -232.296)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M272,272v35.033h32.7a2.336,2.336,0,0,0,2.336-2.336V272Z",
    transform: "translate(-232.296 -232.296)",
    fill: "#ffc107"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(236 106.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    transform: "translate(68 593.004)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 24,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 23,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "OSINT",
    transform: "translate(73.794 610.96)",
    fontSize: 16,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OSINT"))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    transform: "translate(298 710)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    transform: "translate(364 710)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    transform: "translate(333 702) rotate(-90)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    transform: "translate(333 750) rotate(-90)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsOsint);
export default __webpack_public_path__ + "static/media/windowsOSINT.55a2c06494d26dbcb5d00f59d95c95c7.svg";
export { ForwardRef as ReactComponent };